<template>
  <div v-show="value" class="game-activity-root">
    <div v-show="view === 'home'" class="game-activity-bg">
      <div class="left-cont">
        <div class="tit">SPIN BONUS TOTAL</div>
        <div id="amount">{{ displayPool }}</div>
      </div>
      <div class="right-cont swiper-in">
        <div class="swiper-container">
          <div class="swiper-item current">
            <div class="name">{{ currentTicker.name }}</div>
            <div class="win">
              Win:
              <div class="coin">
                <div class="amount amount-str">{{ currentTicker.amount }}</div>
                in
                <div class="type">{{ currentTicker.type }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="game-activity-box">
      <div v-show="view === 'home'" class="game-activity-home">
        <span class="activity-tag2" />
        <div class="activity-content">
          <div class="turnTable">
            <div class="wheel-outer">
              <img class="wheel-outer-img" alt="" :src="img('wheel-bg.png')">
              <div v-show="wheelLoading" class="wheel-loading">
                <h1>Loading, please wait</h1>
              </div>
              <div class="lightAll1" />
              <div class="lightAll2" />
              <div class="wheel" :style="{ transform: 'rotate(' + wheelDeg + 'deg)' }">
                <div class="slice 0"
                  style="transform: rotate(0deg) skewY(-29.9988deg); background: rgb(213, 193, 182);">
                  <div class="text num6">5,000</div>
                </div>
                <div class="slice 1"
                  style="transform: rotate(60.0012deg) skewY(-29.9988deg); background: rgb(217, 45, 84);">
                  <div class="text num6">Deposit<br>&nbsp;&nbsp;15 %</div>
                </div>
                <div class="slice 2"
                  style="transform: rotate(120.002deg) skewY(-29.9988deg); background: rgb(37, 144, 196);">
                  <div class="text num6">Turnover<br>&nbsp;&nbsp;1 %</div>
                </div>
                <div class="slice 3"
                  style="transform: rotate(180.004deg) skewY(-29.9988deg); background: rgb(247, 145, 9);">
                  <div class="text num6">Winlose<br>&nbsp;&nbsp;5 %</div>
                </div>
                <div class="slice 4_0 none"
                  style="transform: rotate(240deg) skewY(-30deg) translate(-1px, 3px); background: rgb(83, 158, 50);">
                  <div class="text num6 none_1">&nbsp;&nbsp; Zonk</div>
                </div>
                <div class="slice 4_1 none"
                  style="transform: rotate(300deg) skewY(-30deg) translate(-1px, 3px); background: rgb(83, 158, 50);">
                  <div class="text num6 none_2">&nbsp;&nbsp; Zonk</div>
                </div>
              </div>
              <div class="wheel-pointer" role="button" tabindex="0" @click="startDraw" @keyup.enter="startDraw" />
            </div>
          </div>
        </div>
        <a href="javascript:;" class="activity-button" @click.prevent="startDraw" />
        <a href="javascript:;" class="activity-link-l" @click.prevent="view = 'history'">
          <span>My<br>Prizes</span>
          <i style="display: none;" />
        </a>
        <a href="javascript:;" class="activity-link-r" @click.prevent="view = 'rule'">
          <span>Event Rules</span>
        </a>
        <a href="javascript:;" class="activity-close" @click.prevent="close" />
        <!-- <a href="javascript:;" class="music-icon" :class="{ open: musicOn }" @click.prevent="toggleMusic" /> -->
        <div class="activity-prize-box" />
        <div class="start1" />
        <div class="start2" />
        <div class="start3" />
        <div class="start4" />
        <div class="start5" />
      </div>

      <div class="game-activity-history" :style="panelDisplay('history')">
        <div class="history-title">
          My Prizes
          <a href="javascript:;" class="box-back" @click.prevent="view = 'home'" />
        </div>
        <div class="history-list">
          <ul>
            <li class="noPrizesData">Belum ada riwayat hadiah</li>
          </ul>
        </div>
      </div>

      <div class="game-activity-rule" :style="panelDisplay('rule')">
        <div class="rule-notify">
          <div class="rule-close" @click.prevent="view = 'home'" />
          <div class="rule-notify-contain">
            <h3>Syarat dan Ketentuan</h3>
            <div class="rule-content wheel-rule-html" v-html="ruleHtml" />
            <div class="rule-btn" @click.prevent="view = 'home'">
              <h1>OK</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <audio ref="music1" :src="img('music1.mp3')" preload="auto" loop />
    <audio ref="music2" :src="img('turnTable.mp3')" preload="auto" loop />
    <audio ref="music3" :src="img('success.mp3')" preload="auto" />
    <audio ref="music4" :src="img('fail.mp3')" preload="auto" />
  </div>
</template>

<script>
const CDN_BASE = 'https://png-res.png999.com/resources/images/game-activity/'

export default {
  name: 'GameActivityWheel',
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      view: 'home',
      wheelDeg: 0,
      wheelSpinning: false,
      wheelLoading: false,
      musicOn: false,
      totalBonusPool: 64239516,
      tickerIndex: 0,
      tickerRows: [
        { name: 'horman***', amount: '7.500 ', type: 'depositChip' },
        { name: 'playboyj***', amount: '2.447 ', type: 'winloseBonus' },
        { name: 'made1***', amount: '3.750 ', type: 'depositChip' },
        { name: 'cuan***', amount: '5.000 ', type: 'freeChip' },
        { name: 'pudinv***', amount: '1.374 ', type: 'turnoverBonus' }
      ],
      tickerTimer: null,
      ruleHtml: `
        <div class="terms-and-conditions">
          <h2>Syarat dan Ketentuan:</h2>
          <ol>
            <li>Memiliki transaksi dan deposit di hari sebelumnya</li>
            <li>Apabila ditemukan kecurangan atau transaksi tidak normal, maka bonus dianggap hangus.</li>
            <li>Semua keputusan management bersifat mutlak dan tidak dapat diganggu gugat.</li>
          </ol>
        </div>
        <div class="bonuses">
          <h2>Bonusnya:</h2>
          <ol>
            <li><h3 class="free-chips">Free Chips 5.000,-</h3><p>Free chips, bonus langsung masuk ke saldo.</p></li>
            <li><h3 class="bonus-deposit">Bonus Deposit 15%</h3><p>Bonus deposit dari transaksi hari sebelumnya.</p></li>
            <li><h3 class="bonus-cashback">Bonus Cashback Kekalahan 5%</h3><p>Cashback dari total kalah hari sebelumnya.</p></li>
            <li><h3 class="bonus-rollingan">Bonus Rollingan Turnover 1%</h3><p>Bonus rolling dari turnover hari sebelumnya.</p></li>
            <li><h3 class="zonk">Zonk</h3><p>Belum beruntung, coba lagi besok.</p></li>
          </ol>
        </div>`
    }
  },
  computed: {
    displayPool() {
      return 'Rp ' + new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(Number(this.totalBonusPool) || 0)
    },
    currentTicker() {
      return this.tickerRows[this.tickerIndex] || this.tickerRows[0]
    }
  },
  watch: {
    value(open) {
      if (open) {
        this.view = 'home'
        this.startTicker()
      } else {
        this.stopTicker()
        this.stopMusicAll()
      }
    }
  },
  beforeDestroy() {
    this.stopTicker()
  },
  methods: {
    img(name) {
      return CDN_BASE + name
    },
    panelDisplay(name) {
      return { display: this.view === name ? 'block' : 'none' }
    },
    close() {
      this.$emit('input', false)
    },
    startTicker() {
      this.stopTicker()
      this.tickerTimer = setInterval(() => {
        this.tickerIndex = (this.tickerIndex + 1) % this.tickerRows.length
      }, 2500)
    },
    stopTicker() {
      if (this.tickerTimer) {
        clearInterval(this.tickerTimer)
        this.tickerTimer = null
      }
    },
    startDraw() {
      if (this.wheelSpinning || this.view !== 'home') return
      this.wheelSpinning = true
      const rounds = 5 + Math.floor(Math.random() * 3)
      const extra = Math.random() * 360
      this.wheelDeg += rounds * 360 + extra
      window.setTimeout(() => {
        this.wheelSpinning = false
      }, 5000)
    },
    toggleMusic() {
      this.musicOn = !this.musicOn
      if (this.musicOn) {
        try {
          this.$refs.music1 && this.$refs.music1.play()
        } catch (e) { }
      } else {
        this.stopMusicAll()
      }
    },
    stopMusicAll() {
      ;['music1', 'music2', 'music3', 'music4'].forEach((k) => {
        const el = this.$refs[k]
        if (el) {
          el.pause()
          el.currentTime = 0
        }
      })
      this.musicOn = false
    }
  }
}
</script>

<style scoped>
.game-activity-root {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
}

.game-activity-root>>>.game-activity-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: transparent !important;
  pointer-events: none;
}

.game-activity-root>>>.game-activity-bg .left-cont,
.game-activity-root>>>.game-activity-bg .right-cont {
  position: fixed;
  pointer-events: auto;
  z-index: 3;
}

.game-activity-root>>>.game-activity-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1 !important;
}

.game-activity-root>>>.game-activity-box .game-activity-history,
.game-activity-root>>>.game-activity-box .game-activity-rule {
  position: fixed;
  inset: 0;
  z-index: 100 !important;
}

.wheel-rule-html>>>.terms-and-conditions,
.wheel-rule-html>>>.bonuses {
  padding: 16px;
  border-radius: 10px;
}

.wheel-rule-html>>>.terms-and-conditions {
  background-color: #f2f2f2;
}

.wheel-rule-html>>>.bonuses {
  background-color: #e6f7ff;
  margin-top: 16px;
}

.wheel-rule-html>>>ol {
  padding-left: 1.2em;
}
</style>
